let formatter = new Intl.NumberFormat('nl-NL', {
	maximumFractionDigits: 0,
	useGrouping: true,
})
export default () => ({
	duration: 200,
	start: 0,

	appendage: '',
	end: 0,

	target: null,

	init() {
		this.$nextTick(() => this.setupData())
	},

	setupData() {
		this.target = this.$root.querySelector('[data-target]')

		this.end = parseInt(this.target.textContent)
		this.appendage = this.target.textContent.replace(this.end, '')

		if (this.$el.dataset.duration ?? false) {
			this.duration = this.$el.dataset.duration
		}

		this.$nextTick(() => this.animate())
	},

	animate() {
		if (!this.target || Number.isNaN(this.end)) {
			return
		}
		let startTime = null

		const step = (timestamp) => {
			if (!startTime) startTime = timestamp
			const progress = Math.min((timestamp - startTime) / this.duration, 1)
			this.target.innerHTML = `${formatter.format(Math.floor(progress * (this.end - this.start) + this.start))}${
				this.appendage
			}`
			if (progress < 1) {
				window.requestAnimationFrame(step)
			}
		}

		window.requestAnimationFrame(step)
	},
})
